import './PayInfo.less';

export const prefix = 'bm-c-pay-info';

export { default } from './PayInfo';
